export default __webpack_public_path__ + "static/media/undeadminionharvester.35773157.png";